import React, {useState, useContext, useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Navigate } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import NativeSelect from '@material-ui/core/NativeSelect';
import Button from '@material-ui/core/Button';
import PasswordComponent from '../commonComponents/PasswordComponent'

import UserTable from '../tables/adminTables/UserTable'

import * as AdminWorker from '../../workers/adminWorker'
import { UsersContext } from '../../context/users-context';

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		width: "100vw",
		height: "100vh",
		backgroundColor: theme.palette.background.default,
	},
	form: {
		width: "500px",
		boxShadow: "0px 0px 10px 1px rgba(253, 253, 253, 0.2)",
		boxSizing: "border-box",
		borderRadius: "6px",
		display: "flex",
		flexDirection: "column",
		padding: "1em",
		[theme.breakpoints.down(600)]: {
			width: 300,
		}
	},
	title: {
		color: "rgba(255, 255, 255, 0.7)",
		fontSize: "1.25em",
	},
	commonSpacing: {
		marginLeft: theme.spacing(1),
		marginRight: theme.spacing(1),
	},
	text: {
		marginBottom: "1em",
  },

	alert: {
		backgroundColor: "#f44336",
		color: "white",
		height: "0",
		lineHeight: "3em",
    borderRadius: "0.3em",
    marginBottom: "1em",
    overflow: "hidden",
    transition: "height 0.4s"
  },
  alertVisible: {
    height: "3em",
  }
}));


export default function AuthComponent(props) {
  console.log("render AuthComponent");

  const classes = useStyles();
  const [usersState, usersDispatch] = useContext(UsersContext);
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [redirect, setRedirect] = useState(false);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
		document.addEventListener("keydown", loginByClick);
		return () => {
			document.removeEventListener("keydown", loginByClick);
		};
  }, [login, password]);
  
  if (redirect) {
    return <Navigate to="/info/equip/main" replace/>;  
  }

  const onLoginChange = (ev) => {
    setLogin(ev.target.value);
    if(showError)setShowError(false);
  }; 
  
  const onPasswordChange = (ev) => {
    setPassword(ev.target.value);
    if(showError)setShowError(false);
  }; 

  const onEmailChange = (ev) => {
    setEmail(ev.target.value);
    if(showError)setShowError(false);
  }; 

  const onLogin = async () => {
    const parseJwt = (token) => {
      try {
        return JSON.parse(atob(token.split('.')[1]));
      } catch (e) {
        return null;
      }
    };
    const data = await AdminWorker.Login({login, password, email});
    
    if(data && data.Token){
      const claims = parseJwt(data.Token);      
      usersDispatch({ type: 'SETUSER', payload: {Token: data.Token, Claims: claims, Surname: data.Surname} }); 
      setRedirect(true);
    }
    else{
      setShowError(true);
    }
  };

  const loginByClick = (e) => { 
    if (e.key === "Enter") {
      onLogin();
    }
  }

  return (
		<div className={classes.root}>
			<div className={classes.form}>
				<div className={classes.title}>Авторизация</div>
				<TextField
					className={classes.text}
					id="standard-basic"
					label="Логин"
					defaultValue={""}
					onChange={onLoginChange}
					autoFocus
				/>
				{/* <TextField className={classes.text} id="standard-basic" label="Пароль" defaultValue={''} onChange={onPasswordChange}/> */}
				<PasswordComponent
					password={password}
					onChange={onPasswordChange}></PasswordComponent>
				<TextField
					className={classes.text}
					id="standard-basic"
					label="Почта"
					defaultValue={""}
					onChange={onEmailChange}
				/>
        <div className={`${classes.alert} ${showError ? classes.alertVisible : ``}`}>
          Логин или пароль неверны
        </div>
				<Button
					variant="contained"
					color="primary"
					onClick={onLogin}>
					Login
				</Button>
			</div>
		</div>
	);
}